import { UserSelectableEntityResponseDto } from "./users";

export enum UserRole {
  Admin = "ADMIN",
  User = "USER",
  SuperAdmin = "SUPERADMIN",
}

export interface UserInformationResponseDto {
  role: UserRole;
  profilePictureBase64?: string;
}

export interface UserProfileResponseDto {
  _id: string;
  mail: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  profilePictureBase64?: string;
  belongsToSalesRankTitle?: string;
  downlineHierarchy: UserSelectableEntityResponseDto[];
  uplineHierarchy: UserSelectableEntityResponseDto[];
}
